import React from "react";

interface ProgressBarProps {
  value: number;
  max?: number;
  color?: "accent" | "green" | "amber" | "red";
  size?: "sm" | "md";
}

export function ProgressBar({ value, max = 100, color = "accent", size = "sm" }: ProgressBarProps) {
  const pct = Math.min(100, (value / max) * 100);
  const colors = {
    accent: "var(--c-accent)",
    green: "var(--c-success)",
    amber: "var(--c-warning)",
    red: "var(--c-danger)",
  };
  const h = size === "sm" ? "4px" : "8px";
  return (
    <div
      className="w-full rounded-full overflow-hidden"
      style={{ height: h, backgroundColor: "var(--c-border)" }}
    >
      <div
        className="rounded-full transition-all duration-500 ease-out"
        style={{ width: `${pct}%`, height: h, backgroundColor: colors[color] }}
      />
    </div>
  );
}
